import { Loader2 } from 'lucide-react'
import { useManagerStats } from '@/hooks/useManagerSubmissions'

interface StatCardProps {
  label: string
  value: number | undefined
  isLoading: boolean
}

function StatCard({ label, value, isLoading }: StatCardProps) {
  return (
    <div className="rounded-xl border-2 border-[#d6dae1] bg-white shadow-sm p-6">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        {label}
      </p>
      {isLoading ? (
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground mt-2" />
      ) : (
        <p className="text-[32px] font-semibold text-foreground mt-1">
          {value ?? 0}
        </p>
      )}
    </div>
  )
}

export function ApprovalsStatsCards() {
  const { data, isLoading } = useManagerStats()

  return (
    <div className="grid grid-cols-3 gap-4">
      <StatCard
        label="New Requests"
        value={data?.new_count}
        isLoading={isLoading}
      />
      <StatCard
        label="Total Requests"
        value={data?.pending_count}
        isLoading={isLoading}
      />
      <StatCard
        label="Requests Followed-Up"
        value={data?.sent_back_count}
        isLoading={isLoading}
      />
    </div>
  )
}
